<template>
    <div class="container" id="reservation">
        <h2 v-translate>Votre demande de réservation</h2>
        <ul class="grid">
            <li>
                <h3>
                    <span>1/4</span>
                    <div>
                         {{ t('Validation de la carte SIVEC')}} <a href="#" v-scroll-to="'#validation-carte'"><svg height="22" class="edit" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m18.512685 0h-.6876811l-2.6509899 2.65499441 4.1740139 4.17877095 2.6519721-2.65499441v-.6884648zm-16.59735275 15.9287374-1.91533225 6.0712626 6.06435124-1.9175151 11.53992096-11.55307261-4.1740139-4.17877095z" fill="#fff"/></svg></a>
                    </div>
                </h3>
                <table>
                    <tr>
                        <th v-translate>Statut</th>
                        <td v-translate>approuvé</td>
                    </tr>
                    <tr>
                        <th v-translate>Nr. de la carte SIVEC</th>
                        <td>{{ this.$store.state.sivecNumber }}</td>
                    </tr>
                </table>
            </li>
            <li></li>
            <li>
                <h3>
                    <span>2/4</span>
                    <div>
                         {{ t('Votre véhicule')}} <a href="#" v-scroll-to="'#vehicule'"><svg height="22" class="edit" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m18.512685 0h-.6876811l-2.6509899 2.65499441 4.1740139 4.17877095 2.6519721-2.65499441v-.6884648zm-16.59735275 15.9287374-1.91533225 6.0712626 6.06435124-1.9175151 11.53992096-11.55307261-4.1740139-4.17877095z" fill="#fff"/></svg></a>
                    </div>
                </h3>
                <div class="warning" v-if="this.$store.state.plateNumber.length === 0">
                    <img src="../assets/ui/exclamation--round.svg" alt=""><span v-translate>Numéro de plaque indispensable</span> {{ t("On a besoin de votre numéro de plaque pour vérifier le rendez-vous sur place")}}
                </div>
                <div class="warning" v-if="this.$store.state.vehicleType.length === 0">
                    <img src="../assets/ui/exclamation--round.svg" alt=""><span v-translate>Type de véhicule indispensable</span> {{ t('On a besoin de votre type de véhicule pour pouvoir vous réserver un parking adapté')}}
                </div>
                <table>
                    <tr v-if="this.$store.state.plateNumber.length > 0">
                        <th v-translate>Numéro de plaque</th>
                        <td>{{ this.$store.state.plateNumber }}</td>
                    </tr>
                    <tr v-if="this.$store.state.vehicleType.length > 0">
                        <th v-translate>Type de véhicule</th>
                        <td>{{ this.$store.state.vehicleType }}</td>
                    </tr>
                </table>
            </li>
            <li></li>
            <li>
                <h3>
                    <span>3/4</span>
                    <div>
                         {{ t('Votre matériel à décharger')}} <a href="#" v-scroll-to="'#materiaux'"><svg height="22" class="edit" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m18.512685 0h-.6876811l-2.6509899 2.65499441 4.1740139 4.17877095 2.6519721-2.65499441v-.6884648zm-16.59735275 15.9287374-1.91533225 6.0712626 6.06435124-1.9175151 11.53992096-11.55307261-4.1740139-4.17877095z" fill="#fff"/></svg></a>
                    </div>
                </h3>
                <div class="warning" v-if="this.$store.state.materialSelection.length === 0">
                    <img src="../assets/ui/exclamation--round.svg" alt=""><span v-translate>Type de matériel indispensable</span> {{ t('Merci de choisir le type de matériel que vous souhaitez déposer')}}
                </div>
                <table>
                    <tr v-for="id in this.$store.state.materialSelection" v-bind:key="id">
                        <th>{{ getWasteTypeNameById(id) }}</th>
                    </tr>
                </table>
            </li>
            <li></li>
            <li>
                <h3>
                    <span>4/4</span>
                    <div>
                         {{ t('Contact')}} <a href="#" v-scroll-to="'#contact'"><svg height="22" class="edit" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m18.512685 0h-.6876811l-2.6509899 2.65499441 4.1740139 4.17877095 2.6519721-2.65499441v-.6884648zm-16.59735275 15.9287374-1.91533225 6.0712626 6.06435124-1.9175151 11.53992096-11.55307261-4.1740139-4.17877095z" fill="#fff"/></svg></a>
                    </div>
                </h3>
                <div class="warning" v-if="!this.$store.state.phone && this.$store.state.phone.length === 0">
                    <img src="../assets/ui/exclamation--round.svg" alt=""><span v-translate>Numéro de téléphone indispensable</span> {{ t("On a besoin de votre numéro de téléphone comme moyen de contact pour votre réservation.")}}
                </div>
                <table>
                    <tr v-if="this.$store.state.phone && this.$store.state.phone.length > 0">
                        <th v-translate>Numéro de téléphone</th>
                        <td>{{ this.$store.state.phone }}</td>
                    </tr>
                    <tr v-if="this.$store.state.email && this.$store.state.email.length > 0">
                        <th v-translate>Adresse e-mail</th>
                        <td>{{ this.$store.state.email }}</td>
                    </tr>
                </table>
            </li>
        </ul>
        <div class="time">
            <Watch />
            <div class="time__information">
                <h3>{{ t('Date et heure sollicitées')}} <a href="#" v-scroll-to="'#date'"><svg height="22" class="edit" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><path d="m18.512685 0h-.6876811l-2.6509899 2.65499441 4.1740139 4.17877095 2.6519721-2.65499441v-.6884648zm-16.59735275 15.9287374-1.91533225 6.0712626 6.06435124-1.9175151 11.53992096-11.55307261-4.1740139-4.17877095z" fill="#215551"/></svg></a></h3>
                <p v-if="this.$store.state.selectedDate.length > 1 && this.$store.state.selectedTime.length > 1">{{ this.$store.state.selectedDate }} {{ t('à')}} {{ this.$store.state.selectedTime }}</p>
                <p class="time__information__warning" v-if="this.$store.state.selectedDate.length < 1 || this.$store.state.selectedTime.length < 1" v-translate>Veuillez sélectionner la date et l'heure de votre choix</p>
            </div>
        </div>
        <div style="text-align: center">
            <button
                    class="submit"
                    type="submit"
                    v-translate
                    :disabled="(
                        this.$store.state.isSubmitting ||
                        this.$store.state.phone.length === 0 ||
                        this.$store.state.selectedDate.length === 0 ||
                        this.$store.state.selectedTime.length === 0 ||
                        this.$store.state.plateNumber.length === 0 ||
                        this.$store.state.vehicleType.length === 0 ||
                        this.$store.state.materialSelection.length === 0) ? true : false"><span v-if="this.$store.state.isExistingAppointment">Modifier le rendez-vous </span><span v-else>Envoyer la demande</span></button>
        </div>
    </div>
</template>

<script>
  import Watch from './Watch.vue'

    export default {
        name: 'Summary',
        components: {
          Watch
        },
        methods: {
            getWasteTypeNameById(id) {
                let wasteType = this.$store.state.availableWasteTypes.filter(wasteType => {
                    if (wasteType.id === id){
                        return true;
                    }
                });
                return wasteType[0].title;
            }
        }
    }
</script>

<style scoped>
    .container {
        color: white;
        padding: 100px 0;
        position: relative;
    }

    @media only screen and (max-width: 500px) {
        .container {
            padding: 50px 0;
        }
    }

    .container::before {
        content: "";
        background-color: var(--green--dark);
        position: absolute;
        top: 0;
        right: -50vw;
        bottom: 0;
        left: -50vw;
        z-index: -1;
    }

    h2 {
        font-size: 50px;
        margin-top: 100px;
    }

    @media only screen and (max-width: 500px) {
        h2 {
            font-size: 38px;
            margin-top: 50px;
        }
    }

    h2 span {
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        font-size: 24px;
    }

    .grid {
        display: grid;
        gap: var(--xlarge);
        grid-template-columns: 4fr 3fr;
    }

    @media only screen and (max-width: 700px) {
        .grid {
            grid-template-columns: 1fr;
            gap: var(--xmedium);
        }
    }

    h3 {
        font-size: 26px;
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
    }

    h3 span {
        color: var(--green);
        font-size: 21px;
    }

    h3 div {
        display: flex;
        position: relative;
    }

    @media only screen and (max-width: 500px) {
        h3 div {
            justify-content: space-between;
        }
    }

    h3 div a::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    @media only screen and (max-width: 500px) {
        h3 span {
            display: block;
            margin-bottom: 10px;
        }
    }

    h3 a {
        color: white;
    }

    table {
        width: 100%;
    }

    th, td {
        vertical-align: text-top;
    }

    h4 {
        margin-top: 116px;
        font-size: 21px;
    }

    @media only screen and (max-width: 500px) {
        h4 {
            margin-top: 0;
        }
    }

    .submit {
        padding: var(--medium);
        background-color: var(--green);
        border-radius: 30px;
        color: white;
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        margin: 0 auto;
        max-width: 512px;
        text-transform: uppercase;
        text-align: center;
        width: 100%;
    }

    th {
        padding: 5px 0;
    }

    @media only screen and (min-width: 500px) {
        th {
            width: 50%;
        }
    }

    td  {
        padding: 10px 0 10px 15px;
    }

    .time {
        background-color: #E5F2DA;
        border-top-left-radius: 60px;
        border-top-right-radius: 15px;
        border-bottom-right-radius: 60px;
        border-bottom-left-radius: 15px;
        color: var(--green--dark);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: var(--xmedium);
        flex-wrap: wrap;
        margin: 100px 0 40px;
        padding: var(--large);
    }

    .time__information__warning {
        color: var(--orange);
    }

    @media only screen and (max-width: 500px) {
        .time {
            padding: var(--xmedium);
            justify-content: center;
        }
    }

    .time a {
        color: var(--green--dark);
    }

    .time h3 {
        font-size: 26px;
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        margin-top: 0;
        margin-bottom: 15px;
    }

    @media only screen and (max-width: 500px) {
        .time h3 {
            display: flex;
            justify-content: space-between;
            font-size: 21px;
        }
    }

    .time p {
        font-family: montserrat,sans-serif;
        font-weight: 700;
        font-size: 38px;
        margin: 0;
    }

    @media only screen and (max-width: 500px) {
        .time p {
            text-align: center;
            font-size: 26px;
        }
    }

    .edit {
        margin-left: 10px;
    }

    .warning {
        background-color: white;
        border-radius: 7px;
        color: #CF4318;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin: var(--medium) 0;
        padding: 8px 15px;
    }


    .warning span {
        font-weight: bold;
    }

    button:disabled {
        opacity: 0.5;
    }

    button:disabled:hover {
        cursor: not-allowed;
    }

</style>
